import React, { useState } from 'react';
import * as ReactDOM from 'react-dom';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router';
import { Button, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  APPLICANT_ROLES_LIST,
  USER_TYPE,
} from '../../../configs';
import UploadZone from '../../../components/fields/FileInput/UploadZone';
import UploadFileList from '../../System/components/UploadFileList';
import FileView from '../../../components/fields/FileInput/FileView';
import { getApplicationData } from '../../Application/reducer';
import ApplicantForm from '../../Application/components/FormBlocks/ApplicantForm';
import FormHeader from './FormHeader';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import { deleteFile, uploadFile } from '../../System/actions';
import { getResponseError, responseLogWithNotification } from '../../../utils/utils';
import { createApplicant, editApplicant } from '../actions';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';

export default function ApplicantFormMini(props) {
  const {
    onClose = () => {},
    currentApplicant = { legal_entity_type: 1 },
    isEdit = false,
    selectedLegalEntityType,
    loadData = () => {},
  } = props;

  const { loadingEditApplicant, loadingEditApplicationById } = useSelector(getApplicationData);
  const [legalEntityType, setLegalEntityType] = useState();
  const [additionalFiles, setAdditionalFiles] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [loader, setLoader] = useState();
  const dispatch = useDispatch();
  const [defs, setDefs] = useState(isEdit && currentApplicant ? currentApplicant : {
    legal_entity_type: selectedLegalEntityType,
  });

  const [deletedFileList, setDeletedFileList] = useState([]);

  const {
    watch, reset, setValue, control, getValues,
  } = useForm({
    mode: 'onChange',
    defaultValues: defs,
  });

  const deleteUploadFile = index => {
    const newFiles = [...additionalFiles];
    newFiles.splice(index, 1);
    setAdditionalFiles(newFiles);
  };

  const handleChangeFile = newFiles => {
    const values = [...additionalFiles, ...newFiles];
    setAdditionalFiles(values);
  };

  React.useEffect(() => {
    const subscription = watch(values => {
      if (values && typeof values.legal_entity_type !== 'undefined') {
        setLegalEntityType(values.legal_entity_type);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  React.useEffect(() => {
    setValue('application_carrier.has_employees', !legalEntityType);
    setValue('isMatch', legalEntityType === USER_TYPE.LEGAL);
  }, [legalEntityType]);

  React.useEffect(() => {
    reset({});
    setTimeout(() => reset(defs), 100);
  }, [defs]);

  const handleSave = () => {
    const files = [];
    const values = getValues();

    const fileInputs = [
      { list: values?.media?.driver_license_files ? values.media?.driver_license_files : null, name: 'driver_license_files', required: true },
    ];

    for (let i = 0, len = fileInputs.length; i < len; i++) {
      const fileInput = fileInputs[i];
      if (fileInput && fileInput.list) {
        const formFiles = fileInput.list;
        for (let j = 0, len = formFiles.length; j < len; j++) {
          const file = formFiles[j];
          if (file) {
            const data = new FormData();
            data.append('file', file);
            data.append('collection_name', fileInput.name);
            data.append('name', `${fileInput.name}_${j}`);
            files.push(data);
          }
        }
      }
    }

    const action = isEdit ? editApplicant({ ...values, id: currentApplicant.id }) : createApplicant(values);

    const loadFiles = files;

    dispatch(action)
      .then(applicant => {
        const promiseNotification = [];
        successNotification('Сохранение формы заявителя', 'Форма сохранена');
        if (deletedFileList && deletedFileList.length) {
          const promises = deletedFileList.map(item => dispatch(deleteFile(item.id)).catch(responseLogWithNotification));
          promiseNotification.push(Promise.all(promises)
            .then(() => {
              successNotification('Удаление файлов заявителя', 'Процесс удаления окончен');
            }));
        }
        if (loadFiles && loadFiles.length && applicant && applicant.id) {
          setLoader(true);
          const promises = loadFiles.map(formData => {
            formData.append('model_type', 'application');
            formData.append('model_id', applicant.id);
            return dispatch(uploadFile(formData)).catch(responseLogWithNotification);
          });
          promiseNotification.push(Promise.all(promises)
            .then(() => {
              successNotification('Сохранение файлов обращения', 'Процесс сохранения окончен');
            }));
        }
        onClose();
        loadData();
        setSearchParams({ applicant_id: applicant.id });
      }).catch(response => {
        errorNotification('Сохранение формы заявителя', getResponseError(response));
      });
  };

  return ReactDOM.createPortal(
    <div className="application-form">
      <TimerLoader loading={loader || loadingEditApplicant || loadingEditApplicationById} />
      <FormHeader onClose={onClose} currentApplicant={defs} isEdit={isEdit} />
      <div className="application-form-body">
        <form className="application-form-content">
          <div className="application-form-fields-header">Заполните информацию о документе</div>
          <div className="application-form-fields">
            <div className="application-form-fields-wrapper custom-scroll-theme">
              <div className="afc-body">
                <div className="afc-main">
                  <Row className="row-cols-1">
                    <FieldDTO
                      control={control}
                      component={CustomSelectInput}
                      dtoObject={{
                        name: 'roles',
                        type: String,
                        labelKey: 'applicant_role',
                      }}
                      variant="material"
                      usePortal
                      withLabel
                      multiple
                      placeholder="Роль заявителя"
                      options={APPLICANT_ROLES_LIST}
                      addPlaceholder
                    />
                  </Row>
                  <ApplicantForm
                    watch={watch}
                    getValues={getValues}
                    setValue={setValue}
                    hideFileInput
                    control={control}
                    applicantType={legalEntityType}
                  />
                  {/* <div className="f4 mt-2">Приложенные файлы</div> */}
                  {/* <div className="application-additional-file"> */}
                  {/*  <UploadFileList list={additionalFiles || []} deleteFile={deleteUploadFile} className="file-list-left" /> */}
                  {/*  <UploadZone */}
                  {/*    type="text" */}
                  {/*    inputProps={{ */}
                  {/*      onChange: handleChangeFile, */}
                  {/*    }} */}
                  {/*    variant="material" */}
                  {/*    withLabel */}
                  {/*    disabled */}
                  {/*    zoneText="Загрузите файл или перетащите файл в эту область" */}
                  {/*  /> */}
                  {/* </div> */}
                  {/* <FileView files={currentApplicant?.files || []} deletedFileList={deletedFileList} setDeletedFileList={setDeletedFileList} isDeleted /> */}
                </div>
              </div>
            </div>
          </div>
          <div className="application-form-footer">
            <Button variant="secondary" onClick={onClose}>Отменить</Button>
            <Button onClick={() => handleSave()}>{isEdit ? 'Сохранить' : 'Создать'}</Button>
          </div>
        </form>
      </div>
    </div>,
    document.getElementById('app-content'),
  );
}
